/**
 * グループオプション - モバイル用スライドパネル
 * モバイル端末用のオプション選択UI
 */

(function() {
  'use strict';

  // 名前空間の初期化
  window.GroupedOptionsMobile = window.GroupedOptionsMobile || {};

  var Utils = window.GroupedOptionsUtils;
  var Visibility = window.GroupedOptionsVisibility;

  /**
   * モバイル用スライドパネルを開く
   * @param {Object} context - コンテキスト（this参照用）
   * @param {string} optionType - オプションタイプ（'required' | 'optional'）
   */
  function openMobileSlidePanel(context, optionType) {
    optionType = optionType || 'required';
    context.currentModalType = optionType;

    // 既存のオーバーレイを削除
    var existingOverlay = document.querySelector('.mobile-option-slide-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }

    // オプションリストを取得（表示ルールでフィルタリング）
    var allOptions = optionType === 'required' ? context.requiredOptions : context.optionalOptions;
    var printColor = Visibility.getCurrentPrintColor();
    var rule = Visibility.getColorVisibilityRule(printColor, context.colorVisibilityRules);

    // 表示ルールに基づいてフィルタリング
    var options = allOptions.filter(function(option) {
      return Visibility.isOptionVisible(option, rule);
    });

    var titleText = optionType === 'required' ? '必須オプション' : '任意オプション';

    // オーバーレイを作成
    var overlay = document.createElement('div');
    overlay.className = 'mobile-option-slide-overlay';
    
    // パネルを作成
    var panel = document.createElement('div');
    panel.className = 'mobile-option-slide-panel';
    
    // ヘッダー
    var header = document.createElement('div');
    header.className = 'mobile-option-slide-header';
    header.innerHTML = 
      '<button type="button" class="mobile-option-back-btn" aria-label="戻る">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">' +
          '<path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path>' +
        '</svg>' +
      '</button>' +
      '<div class="mobile-option-slide-title">' + titleText + '</div>';
    
    // コンテンツ
    var content = document.createElement('div');
    content.className = 'mobile-option-slide-content';
    
    // オプションごとにカテゴリを作成
    options.forEach(function(option) {
      var category = document.createElement('div');
      category.className = 'mobile-option-category';
      
      // カテゴリタイトル
      var categoryTitle = document.createElement('div');
      categoryTitle.className = 'mobile-option-category-title';
      categoryTitle.textContent = option.label;
      category.appendChild(categoryTitle);
      
      // 説明文（あれば）
      if (option.description) {
        var description = document.createElement('div');
        description.className = 'mobile-option-category-description';
        description.innerHTML = Utils.processNewlines(option.description);
        category.appendChild(description);
      }
      
      // 選択肢リスト
      var choicesList = document.createElement('ul');
      choicesList.className = 'mobile-option-choices';
      
      option.choices.forEach(function(choice, index) {
        // choice が null/undefined の場合はスキップ
        if (choice === null || choice === undefined) {
          return;
        }
        
        var choiceItem = document.createElement('li');
        choiceItem.className = 'mobile-option-choice';
        
        var inputType = optionType === 'required' ? 'radio' : 'checkbox';
        var inputName = 'mobile-option-' + option.id;
        var inputId = 'mobile-' + option.id + '-choice-' + index;
        
        // choice が文字列の場合とオブジェクトの場合の両方に対応
        var choiceValue, choiceLabel;
        if (typeof choice === 'string') {
          choiceValue = choice;
          choiceLabel = choice;
        } else {
          choiceValue = choice.value || choice.name || choice.label || '';
          choiceLabel = choice.label || choice.name || choice.value || '';
        }
        
        // 空文字列の場合はスキップ
        if (!choiceValue && !choiceLabel) {
          return;
        }
        
        var isSelected = context.selectedOptions.has(option.id) && 
                        context.selectedOptions.get(option.id).value === choiceValue;
        
        choiceItem.innerHTML = 
          '<input type="' + inputType + '" ' +
            'name="' + inputName + '" ' +
            'id="' + inputId + '" ' +
            'value="' + Utils.escapeHtml(choiceValue) + '" ' +
            (isSelected ? 'checked' : '') + ' ' +
            'data-option-id="' + option.id + '" ' +
            'data-choice-index="' + index + '">' +
          '<label for="' + inputId + '" class="mobile-option-choice-label">' +
            '<div class="mobile-option-choice-text">' + Utils.sanitizeChoiceLabel(choiceLabel) + '</div>' +
            (choice.info ? '<div class="mobile-option-choice-info">' + Utils.escapeHtml(choice.info) + '</div>' : '') +
          '</label>';
        
        choicesList.appendChild(choiceItem);
      });
      
      category.appendChild(choicesList);
      content.appendChild(category);
    });
    
    // フッター
    var footer = document.createElement('div');
    footer.className = 'mobile-option-slide-footer';
    footer.innerHTML = '<button type="button" class="mobile-option-confirm-btn">選択を確定</button>';
    
    // 組み立て
    panel.appendChild(header);
    panel.appendChild(content);
    panel.appendChild(footer);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    
    // イベントリスナー
    var backBtn = header.querySelector('.mobile-option-back-btn');
    var confirmBtn = footer.querySelector('.mobile-option-confirm-btn');
    
    // 戻るボタン
    backBtn.addEventListener('click', function() {
      closeMobileSlidePanel(overlay);
    });
    
    // オーバーレイクリック
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeMobileSlidePanel(overlay);
      }
    });
    
    // 確定ボタン
    confirmBtn.addEventListener('click', function() {
      confirmMobileSelection(context, overlay, optionType);
    });
    
    // アニメーション表示
    setTimeout(function() {
      overlay.classList.add('active');
    }, 10);
  }

  /**
   * モバイル用スライドパネルを閉じる
   * @param {HTMLElement} overlay - オーバーレイ要素
   */
  function closeMobileSlidePanel(overlay) {
    overlay.classList.remove('active');
    setTimeout(function() {
      overlay.remove();
    }, 300);
  }

  /**
   * モバイル用選択を確定
   * @param {Object} context - コンテキスト（this参照用）
   * @param {HTMLElement} overlay - オーバーレイ要素
   * @param {string} optionType - オプションタイプ
   */
  function confirmMobileSelection(context, overlay, optionType) {
    // このパネルに表示したオプション（チェックが外れたものを選択から外すために使う）
    var panelOptionIds = [];
    overlay.querySelectorAll('input[data-option-id]').forEach(function(input) {
      if (panelOptionIds.indexOf(input.dataset.optionId) === -1) {
        panelOptionIds.push(input.dataset.optionId);
      }
    });

    var checkedOptionIds = [];
    var inputs = overlay.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

    inputs.forEach(function(input) {
      var optionId = input.dataset.optionId;
      var option = context.allOptions.find(function(opt) { return opt.id === optionId; });

      if (!option) return;

      var choiceIndex = parseInt(input.dataset.choiceIndex, 10);
      var choice = option.choices[choiceIndex];

      if (choice === null || choice === undefined) return;

      checkedOptionIds.push(optionId);

      // PC版（handleChoiceChange）と同じ形で保存する
      // 料金・納期は choiceData の price_modifier / lead_time_modifier から計算される
      var choiceData = Utils.normalizeChoice(choice);
      var existing = context.selectedOptions.get(optionId);

      // 同じ選択肢がPC側で選ばれている場合は、追加入力の値などを残すため上書きしない
      if (existing && existing.choiceData && existing.value === choiceData.value) return;

      context.selectedOptions.set(optionId, {
        value: choiceData.value,
        customSize: false,
        width: null,
        height: null,
        choiceData: choiceData,
        isCheckbox: input.type === 'checkbox'
      });
    });

    // チェックが外れたオプションは選択から外す（ProductOptionsManagerからも削除される）
    panelOptionIds.forEach(function(optionId) {
      if (checkedOptionIds.indexOf(optionId) === -1 && context.selectedOptions.has(optionId)) {
        context.clearOptionSelection(optionId);
      }
    });

    // ProductOptionsManagerに選択内容を適用（このパネルのオプションのみ）
    if (window.productOptionsManager) {
      checkedOptionIds.forEach(function(optionId) {
        var option = context.allOptions.find(function(opt) { return opt.id === optionId; });
        var selection = context.selectedOptions.get(optionId);
        if (!option || !selection) return;

        var choiceToSave = context.buildChoiceToSave(optionId, selection, option);

        if (option.required) {
          window.productOptionsManager.selectedOptions.required[optionId] = choiceToSave;
        } else {
          window.productOptionsManager.selectedOptions.optional[optionId] = choiceToSave;
        }
      });

      if (typeof window.productOptionsManager.recalculatePrice === 'function') {
        window.productOptionsManager.recalculatePrice();
      }
      if (typeof window.productOptionsManager.updateCartProperties === 'function') {
        window.productOptionsManager.updateCartProperties();
      }
    }

    // サイドナビボタンを更新
    context.createSidebarButtons();

    // パネルを閉じる
    closeMobileSlidePanel(overlay);

    document.dispatchEvent(new CustomEvent('optionsUpdated', {
      detail: { selectedOptions: context.selectedOptions }
    }));
  }

  // エクスポート
  window.GroupedOptionsMobile = {
    openMobileSlidePanel: openMobileSlidePanel,
    closeMobileSlidePanel: closeMobileSlidePanel,
    confirmMobileSelection: confirmMobileSelection
  };

})();

